import React from 'react';
import AppContainer from '../app-container';
import * as pageActions from '../../actions/page';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Loading from '../../components/loading';
import DocumentTitle from 'react-document-title';
import HtmlRenderer from '../../components/html-renderer';

class StageRegistrationPageContainer extends AppContainer {

    isEnglish(){
        return this.props.params.slug === this.props.page.item.slug_en;
    }

    componentWillMount() {
        this.props.actions.fetchPageBySlug(this.props.params.slug).then(this.handlePageResult.bind(this));
    }
    renderBody(page) {
        return (
            <div className="container">
                <h1 className="title">
                    <span>{this.isEnglish() ? page.title_en: page.title_lt}</span>
                </h1>
                <div className="post-body-container">
                    <div className="post-body">
                        <HtmlRenderer html={this.isEnglish()? page.body_en: page.body_lt}/>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const {page} = this.props;
        const postTitle = page.item
            ? (this.isEnglish() ? page.item.title_en: page.item.title_lt)
            : '';
        return (
            <DocumentTitle title={this.getDocumentTitle(postTitle)}>

                <div className="page-section">
                    {page.loading
                        ? <Loading/>
                        : this.renderBody(page.item)}
                </div>
            </DocumentTitle>
        )

    }
}
export default connect(function(state) {
    return {page: state.page.page};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...pageActions
        }, dispatch)
    };
})(StageRegistrationPageContainer);



// WEBPACK FOOTER //
// ./src/js/containers/pages/page-page-container.js